import React from 'react';
import { DownloadMobile } from '../../../../components/templateLandings/download-mobile';

const Page = () => <DownloadMobile />;

export default Page;
